import { StateCreator } from 'zustand';

export interface NOAManagerFilters {
  activeTab: 'not_yet_ready' | 'unsent' | 'sent';
  patientSearch: string;
  branchId: string | null;
  payerId: string | null;
  daysLeftFilter:
    | 'all'
    | 'overdue'
    | 'due_today'
    | 'due_tomorrow'
    | 'due_2_5_days';
  statusFilter: string; // 'all' or a specific status value
  errorsFilter: 'all' | 'has_errors' | 'no_errors';
  showInactive: boolean;
  hideTestPatients: boolean;
}

export interface NOASlice {
  noaManagerFilters: NOAManagerFilters;
  setNOAManagerFilters: (filters: Partial<NOAManagerFilters>) => void;
}

const DEFAULT_NOA_FILTERS: NOAManagerFilters = {
  activeTab: 'not_yet_ready',
  patientSearch: '',
  branchId: null,
  payerId: null,
  daysLeftFilter: 'all',
  statusFilter: 'all',
  errorsFilter: 'all',
  showInactive: false,
  hideTestPatients: true,
};

/**
 * Rehydrate persisted filters written before EMR-1528 removed the Missing
 * NOAs tab. A stored `activeTab: 'missing'` has no panel any more, so it
 * lands on Not Yet Ready — where those admissions now appear.
 */
export function migrateNoaManagerFilters(
  filters: Partial<NOAManagerFilters> | undefined
): Partial<NOAManagerFilters> | undefined {
  if (!filters) return filters;
  const activeTab = filters.activeTab as string | undefined;
  if (activeTab === 'missing') {
    return { ...filters, activeTab: 'not_yet_ready' };
  }
  return filters;
}

export const noaSlice: StateCreator<NOASlice> = set => ({
  noaManagerFilters: DEFAULT_NOA_FILTERS,
  setNOAManagerFilters: (filters: Partial<NOAManagerFilters>) =>
    set(state => ({
      noaManagerFilters: { ...state.noaManagerFilters, ...filters },
    })),
});
